import { ROUTE_PATHS } from '../../config/RoutePaths';

export type NavShortcutDef = {
  id: string;
  key: [string, string];
  labelId: string;
  path: string;
};

// Every g+letter combo is taken — new bindings go under the o prefix
// (originally Organization-only, now also the overflow starter).
export const NAV_SHORTCUT_DEFS: NavShortcutDef[] = [
  // Lead Management — top level
  { id: 'go-leads',       key: ['g', 'l'], labelId: 'shortcuts.nav.go_leads',       path: ROUTE_PATHS.LEADS },
  { id: 'go-board',       key: ['g', 'b'], labelId: 'shortcuts.nav.go_board',       path: ROUTE_PATHS.LEADS_BOARD },
  { id: 'go-appointments',key: ['g', 'a'], labelId: 'shortcuts.nav.go_appointments',path: ROUTE_PATHS.APPOINTMENTS },
  { id: 'go-tasks',       key: ['g', 't'], labelId: 'shortcuts.nav.go_tasks',       path: ROUTE_PATHS.TASKS },
  { id: 'go-calendar',    key: ['g', 'k'], labelId: 'shortcuts.nav.go_calendar',    path: ROUTE_PATHS.CALENDAR },
  { id: 'go-dashboard',   key: ['g', 'd'], labelId: 'shortcuts.nav.go_dashboard',   path: ROUTE_PATHS.MY_DAY },
  { id: 'go-calls',       key: ['g', 'c'], labelId: 'shortcuts.nav.go_calls',       path: ROUTE_PATHS.Calls },

  // Lead Management — reports
  { id: 'go-team-overview',  key: ['o', 'v'], labelId: 'shortcuts.nav.go_team_overview',  path: ROUTE_PATHS.TEAM_OVERVIEW },
  { id: 'go-lm-reports',     key: ['g', 'm'], labelId: 'shortcuts.nav.go_lm_reports',     path: ROUTE_PATHS.REPORTS_DASHBOARD_LEAD_MANAGEMENT },
  { id: 'go-team-perf',      key: ['g', 'e'], labelId: 'shortcuts.nav.go_team_perf',      path: ROUTE_PATHS.TEAM_PERFORMANCE },
  { id: 'go-funnel',         key: ['g', 'f'], labelId: 'shortcuts.nav.go_funnel',          path: ROUTE_PATHS.REPORTS_FUNNEL_LEAD_MANAGEMENT },
  { id: 'go-callback',       key: ['g', 'h'], labelId: 'shortcuts.nav.go_callback',        path: ROUTE_PATHS.REPORTS_CALL_BACK_LEAD_MANAGEMENT },

  // Lead Generation — customers
  { id: 'go-lg-customers',   key: ['g', 'n'], labelId: 'shortcuts.nav.go_lg_customers',   path: ROUTE_PATHS.LEAD_GENERATION_CUSTOMERS_LIST },
  { id: 'go-lg-requests',    key: ['g', 'v'], labelId: 'shortcuts.nav.go_lg_requests',    path: ROUTE_PATHS.LEAD_GENERATION_CUSTOMERS_SERVICE_REQUESTS },

  // Lead Generation — reports
  { id: 'go-reports',        key: ['g', 'r'], labelId: 'shortcuts.nav.go_reports',        path: ROUTE_PATHS.REPORTS_DASHBOARD },
  { id: 'go-marketing',      key: ['g', 'o'], labelId: 'shortcuts.nav.go_marketing',      path: ROUTE_PATHS.REPORTS_MARKET_RESEARCH },
  { id: 'go-performance',    key: ['g', 'q'], labelId: 'shortcuts.nav.go_performance',    path: ROUTE_PATHS.REPORTS_PERFORMANCE },
  { id: 'go-cta',            key: ['g', 'x'], labelId: 'shortcuts.nav.go_cta',            path: ROUTE_PATHS.REPORTS_CTA },

  // Lead Generation — content
  { id: 'go-content-settings',  key: ['g', 'j'], labelId: 'shortcuts.nav.go_content_settings',  path: ROUTE_PATHS.CONTENT_SETTINGS },
  { id: 'go-promotions',        key: ['g', 'w'], labelId: 'shortcuts.nav.go_promotions',         path: ROUTE_PATHS.CONTENT_PROMOTIONS },
  { id: 'go-images',            key: ['g', 'z'], labelId: 'shortcuts.nav.go_images',             path: ROUTE_PATHS.CONTENT_IMAGES },

  // Organization (o + letter)
  { id: 'go-org-users',     key: ['o', 'u'], labelId: 'shortcuts.nav.go_org_users',     path: ROUTE_PATHS.ORGANIZATION_USER },
  { id: 'go-org-locations', key: ['o', 'l'], labelId: 'shortcuts.nav.go_org_locations', path: ROUTE_PATHS.ORGANIZATION_LOCATIONS },
  { id: 'go-org-roles',     key: ['o', 'r'], labelId: 'shortcuts.nav.go_org_roles',     path: ROUTE_PATHS.ORGANIZATION_ROLES },
  { id: 'go-org-services',  key: ['o', 's'], labelId: 'shortcuts.nav.go_org_services',  path: ROUTE_PATHS.ORGANIZATION_SERVICE_TYPES },
  { id: 'go-org-fields',    key: ['o', 'e'], labelId: 'shortcuts.nav.go_org_fields',    path: ROUTE_PATHS.ORGANIZATION_EXTRA_FIELD_TYPES },
  { id: 'go-org-products',  key: ['o', 'p'], labelId: 'shortcuts.nav.go_org_products',  path: ROUTE_PATHS.ORGANIZATION_PRODUCT_GROUPS },
  { id: 'go-org-data',      key: ['o', 'd'], labelId: 'shortcuts.nav.go_org_data',      path: ROUTE_PATHS.ORGANIZATION_DATA_ENTRY_MANAGEMENT },

  // Touchpoints
  { id: 'go-email-center',   key: ['o', 'm'], labelId: 'shortcuts.nav.go_email_center',   path: ROUTE_PATHS.EMAIL_CENTER },
  { id: 'go-booking-pages',  key: ['o', 'b'], labelId: 'shortcuts.nav.go_booking_pages',  path: ROUTE_PATHS.TOUCHPOINTS_BOOKING_PAGES },
  // 't' for theme, the editor's long-standing name; 'i' for i18n.
  { id: 'go-design',         key: ['o', 't'], labelId: 'shortcuts.nav.go_design',         path: ROUTE_PATHS.TOUCHPOINTS_DESIGN },
  { id: 'go-translations',   key: ['o', 'i'], labelId: 'shortcuts.nav.go_translations',   path: ROUTE_PATHS.TOUCHPOINTS_TRANSLATIONS },
  { id: 'go-org-sources',    key: ['o', 'c'], labelId: 'shortcuts.nav.go_org_sources',    path: ROUTE_PATHS.TOUCHPOINTS_LEAD_SOURCES },

  // Agents & Tools — the combos are unchanged from when these were three
  // separate menu groups, so nobody's muscle memory breaks with the move.
  { id: 'go-integrations',    key: ['g', 'i'], labelId: 'shortcuts.nav.go_integrations',    path: ROUTE_PATHS.INTEGRATIONS_APPS },
  { id: 'go-api-keys',        key: ['g', 'g'], labelId: 'shortcuts.nav.go_api_keys',        path: ROUTE_PATHS.API_KEYS },
  { id: 'go-exports',         key: ['o', 'x'], labelId: 'shortcuts.nav.go_exports',         path: ROUTE_PATHS.EXPORT_CENTER },
  { id: 'go-automation',      key: ['g', 'u'], labelId: 'shortcuts.nav.go_automation',      path: ROUTE_PATHS.AUTOMATION_TASK },

  // Global
  { id: 'go-settings',      key: ['g', 's'], labelId: 'shortcuts.nav.go_settings',      path: ROUTE_PATHS.SETTINGS },
  { id: 'go-profile',       key: ['g', 'p'], labelId: 'shortcuts.nav.go_profile',       path: ROUTE_PATHS.PROFILE },
];

// Route path → key combo map, used to render ShortcutHint badges on sidebar items
export const NAV_SHORTCUTS: Record<string, [string, string]> = Object.fromEntries(
  NAV_SHORTCUT_DEFS.map(({ path, key }) => [path, key]),
);

// Ctrl/Cmd shortcut keys used in LeadManagementQuickActions
export const CMD_SHORTCUTS = {
  ADD_LEAD: 'g',
  BOOK_APPOINTMENT: 'l',
} as const;

// Single-key shortcuts
export const SINGLE_SHORTCUTS = {
  RELOAD_LEADS: 'r',
  // Toggles the filter popover on every filterable page (leads, board,
  // tasks, appointments, calendar) — keep it conflict-free on all of them
  OPEN_FILTERS: 'f',
} as const;

// Email visual editor. Handled locally by the editor surface, not through
// KeyboardShortcutsProvider: the provider suppresses every binding while
// ctrl/meta is held (and while focus sits in an input), which is exactly when
// these must fire. Same arrangement as CMD_SHORTCUTS in
// LeadManagementQuickActions — the keys still live here, only the listener is
// local. Mapping from event to editor action: EmailBodyEditor/visual/keymap.ts.
export const EMAIL_EDITOR_SHORTCUTS = {
  /** With ⌘/Ctrl; add Shift to redo. */
  UNDO: 'z',
  /** With Ctrl, for the Windows convention. */
  REDO: 'y',
  /** With ⌘/Ctrl. */
  DUPLICATE: 'd',
} as const;

// Calendar page shortcuts
export const CALENDAR_SHORTCUTS = {
  PREV_PERIOD: 'j',
  NEXT_PERIOD: 'k',
  PREV_MONTH: 'h',
  NEXT_MONTH: 'l',
  TODAY: 't',
  ME_MODE: 'm',
} as const;
